import React, { Component } from 'react'
import { View, StyleSheet, ActivityIndicator } from 'react-native'
import Theme from '../theme';
import { MusicPlatformButton } from '../ui/components';
import { MusicPlatformConfig, musicPlatform } from 'fitbeat.gym-core';
import { CardioOrResistance } from 'fitbeat.models';

export default class MusicPlatforms extends Component {
    constructor(props) {
        super(props)

        this.state = {
            platformLinkList: MusicPlatformConfig.platformList,
            isLoading: false,
        }
    }
    updateLoadingState = (loadingState) => {
        this.setState({ isLoading: loadingState })
    }

    render() {
        const { platformLinkList, isLoading } = this.state
        const { workoutSettings, isGroupWorkout } = this.props;
        const isBurnWorkout = workoutSettings.cardioOrResistance === CardioOrResistance.Cardio;
        const isBuildWorkout = workoutSettings.cardioOrResistance === CardioOrResistance.Resistance;
        if (isLoading) {
            return (
                <View style={styles.loadingContainer}>
                    <ActivityIndicator
                        size="small"
                        color={Theme.PRIMARY}
                        animating={isLoading}
                        style={styles.activityIndicator}
                    />
                </View>
            );
        }
        return (
            <View style={{ flex: 1 }}>
                {platformLinkList.map(singleMusicPlatform => {
                    const playlistLink = isBurnWorkout ? singleMusicPlatform.burnPlaylistLink
                                       : isBuildWorkout ? singleMusicPlatform.buildPlaylistLink
                                       : singleMusicPlatform.balancePlaylistLink;
                    return <MusicPlatformButton
                        isGroupWorkout={isGroupWorkout}
                        platformLink={playlistLink}
                        platformTitle={singleMusicPlatform.platformName}
                        playlistSubText={singleMusicPlatform.subHeading}
                        closeModal={this.props.closeModal}
                        isBurnWorkout={isBurnWorkout}
                        shouldAutoScroll={singleMusicPlatform.shouldScroll}
                        scrollToBottom={this.props.scrollToBottom}
                        updateLoadingState={this.updateLoadingState}
                        userProfile={this.props.userProfile}
                    />
                })}
            </View>
        )
    }
}
const styles = StyleSheet.create({
    loadingContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
    activityIndicator: {
        flex: 1,
        alignSelf: 'center',
    },
})
